;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('inputNumberButtons', inputNumberButtons)

  /* @ngInject */
  function inputNumberButtons () {
    return {
      restrict: 'EA',
      scope: {
        modelPropertyName: '@',
        model: '=',
        disabled: '<',
        readOnly: '<',
        change: '=',
        placeholder: '@',
        minValue: '<',
        maxValue: '<'
      },
      templateUrl: '/core/directives/input-number-buttons/input-number-buttons-directive.html?$$REVISION$$',
      controller: 'InputNumberButtonsController'
    }
  }
})()
